import { labels } from '../WorkflowContext';

type Kind = 'st' | 'dp' | 'pr';

/** status / dept / priority pill */
export default function Tag({ kind, value }: { kind: Kind; value: string }) {
  const text = kind === 'st' ? labels.status(value) : labels.dept(value);
  return <span className={`tag ${kind}-${value}`}>{text}</span>;
}

export function Toast({ toast }: { toast: { title: string; msg: string } | null }) {
  if (!toast) return null;
  return (
    <div className="toast">
      <strong>{toast.title}</strong>
      <span>{toast.msg}</span>
    </div>
  );
}
